import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {apiRequest} from '../../utils/AxiosHelper';
import API from '../../modules/settings/APIs';
import {EventFilterCriteria} from '../../types/events';

const searchEvents = async (criteria: EventFilterCriteria) => {
  const response = await apiRequest.post(API.events.filter.search, criteria);
  return response.data;
};

export const useFilterEvent = (
  criteria: EventFilterCriteria,
  options?: {enabled?: boolean}
) => {
  return useQuery({
    queryKey: ['searchEvents', criteria],
    queryFn: () => searchEvents(criteria),
    enabled: options?.enabled ?? false,
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000,
    retry: 2,
  });
};
